/**
 * @file Define a theme that we can apply to the app
 */

import { createMuiTheme } from '@material-ui/core/styles';

import colors from './colors';

const theme = createMuiTheme({
    palette: {
        primary: {
            main: colors.darkGreen,
            contrastText: colors.white,
        },
        secondary: {
            main: colors.white,
            contrastText: colors.black,
        },
        success: {
            main: colors.darkGreen,
            contrastText: colors.white,
        },
        error: {
            main: colors.shyTomato,
            contrastText: colors.white,
        }
    },
    typography: {
        fontFamily: '"Roboto Slab" , Garamond , "Times New Roman" , "游明朝" , "Yu Mincho" , "游明朝体" , "YuMincho" , "ヒラギノ明朝 Pro W3" , "Hiragino Mincho Pro" , "HiraMinProN-W3" , "HGS明朝E" , "ＭＳ Ｐ明朝" , "MS PMincho" , serif',
        fontSize: 14,
    }
});

export default theme;